<template>
  <v-row align="center" no-gutters>
    <v-col v-if="isPrependIcon" cols="auto">
      <slot name="prependIcon" v-bind="$props">
        <v-icon :color="disabled ? 'disabled' : 'success'" class="pr-1">
          mdi-check
        </v-icon>
      </slot>
    </v-col>
    <v-col cols="auto">
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="text-body-2" :class="{ 'text--disabled': disabled }"> {{ fileName }} </span>
        </v-col>
      </v-row>
      <v-row v-if="!!date" no-gutters>
        <v-col cols="auto">
          <italic-subheader :disabled="disabled" translation-path="admin.addDate" :params="{ date: dateFormatted }" />
        </v-col>
      </v-row>
    </v-col>
    <v-spacer />
    <v-col cols="auto">
      <dots-menu :items="dotsMenuItems" v-on="$listeners" :disabled="disabled" />
    </v-col>
  </v-row>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'AddedFileInfo',
  components: {
    DotsMenu,
    ItalicSubheader,
  },
  props: {
    isPrependIcon: {
      type: Boolean,
      default: true,
    },
    date: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      required: true,
    },
    dotsMenuItems: {
      type: Array,
      default: () => [
        {
          name: 'delete',
        },
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dateFormatted() {
      return this.date ? this.$dayjs(this.date).format('L') : '';
    },
  },
};
</script>
